<template>
  <div>
    <a-row class="iotplt-card-box">
      <a-col>
        <a-form
          class="iotplt-compact-form"
          :form="form"
          label-align="left"
          :label-col="{ span: 2 }"
          :wrapper-col="{ span: 20 }"
        >
          <a-form-item
            label="模组厂商"
            :style="{ marginBottom: 0 }"
          >
            <a-spin :spinning="loadingProducers">
              <a-radio-group
                button-style="solid"
                @change="handleProducerChange"
                v-decorator="['module_producer_id', {
                  rules: [{ required: true, message: '请选择厂商' }]
                }]"
              >
                <a-radio-button
                  class="card-select-box card-type-box"
                  v-for="producer in producerOptions"
                  :key="producer.id"
                  :value="producer.id"
                >
                  {{ producer.name }}
                </a-radio-button>
              </a-radio-group>
            </a-spin>
          </a-form-item>

          <a-form-item
            label="模组型号"
          >
            <a-spin :spinning="loadingModels">
              <a-radio-group
                button-style="solid"
                @change="handleModelChange"
                v-decorator="['module_model_id', {
                  rules: [{ required: true, message: '请选择模组型号' }]
                }]"
              >
                <a-radio-button
                  class="card-select-box card-shape-box"
                  v-for="model in modelOptions"
                  :key="model.id"
                  :value="model.id"
                >
                  {{ model.name }}
                </a-radio-button>
              </a-radio-group>
              <a-empty
                v-if="!loadingModels && selectedProducerId && modelOptions.length === 0"
                description="该厂商暂无模组型号"
                :image="simpleImage"
              />
            </a-spin>
          </a-form-item>

          <a-descriptions
            :column="1"
            class="iotplt-descriptions iotplt-descriptions-max-6"
          >
            <a-descriptions-item label="库存量">
              <a-spin :spinning="loadingInventory" size="small">
                <span v-if="selectedModelId">{{ inventoryCountDisplay }}</span>
                <span v-else class="placeholder-text">-</span>
              </a-spin>
            </a-descriptions-item>
          </a-descriptions>
        </a-form>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { Empty } from 'ant-design-vue'
import { findCommonTypeOptions } from '@/api/common_type'
import { findModuleInventoryStatistics } from '@/api/module_inventory'

export default {
  name: 'SalesInventoryCheckModules',
  beforeCreate() {
    this.simpleImage = Empty.PRESENTED_IMAGE_SIMPLE
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'sales_inventory_check_modules' }),
      producerOptions: [],
      modelOptions: [],
      selectedProducerId: undefined,
      selectedModelId: undefined,
      inventoryCount: null,
      loadingProducers: false,
      loadingModels: false,
      loadingInventory: false
    }
  },
  computed: {
    inventoryCountDisplay() {
      if (this.inventoryCount === null || this.inventoryCount === undefined) {
        return '-'
      }
      return this.inventoryCount
    }
  },
  created() {
    this.fetchProducerOptions()
  },
  methods: {
    fetchProducerOptions() {
      this.loadingProducers = true
      findCommonTypeOptions('product_module_producer').then((res) => {
        if (res.code === 0) {
          this.producerOptions = res.data || []
        }
        this.loadingProducers = false
      }).catch(() => {
        this.loadingProducers = false
      })
    },

    fetchModelOptions(producerId) {
      this.modelOptions = []
      if (!producerId) {
        return
      }
      this.loadingModels = true
      findCommonTypeOptions('product_module_model', undefined, producerId).then((res) => {
        if (res.code === 0) {
          this.modelOptions = res.data || []
        }
        this.loadingModels = false
      }).catch(() => {
        this.loadingModels = false
      })
    },

    fetchInventory(moduleModelId) {
      this.inventoryCount = null
      if (!moduleModelId) {
        return
      }
      this.loadingInventory = true
      findModuleInventoryStatistics({
        module_model_id: moduleModelId,
        page: 1,
        per_page: 1
      }).then((res) => {
        if (res.code === 0) {
          const row = (res.data || [])[0]
          this.inventoryCount = row ? row.inventory_count : 0
        }
        this.loadingInventory = false
      }).catch(() => {
        this.loadingInventory = false
      })
    },

    handleProducerChange(e) {
      const producerId = e.target.value
      this.selectedProducerId = producerId
      this.selectedModelId = undefined
      this.inventoryCount = null
      this.form.setFieldsValue({ module_model_id: undefined })
      this.fetchModelOptions(producerId)
    },

    handleModelChange(e) {
      const modelId = e.target.value
      this.selectedModelId = modelId
      this.fetchInventory(modelId)
    }
  }
}
</script>

<style lang="less" scoped>
.card-select-box {
  margin: 0 10px 5px 0;
  border-radius: 0 !important;
  border: 1px solid #d9d9d9;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &.card-type-box {
    min-width: 115px;
    max-width: 240px;
  }

  &.card-shape-box {
    min-width: 105px;
    max-width: 220px;
  }
}

.placeholder-text {
  color: rgba(0, 0, 0, 0.45);
}
</style>
